/* gorilla-nutrition-modal.js */
(function () {
  'use strict';

  var scrollY = 0;

  function lockScroll() {
    scrollY = window.scrollY;
    document.body.style.position = 'fixed';
    document.body.style.top = '-' + scrollY + 'px';
    document.body.style.width = '100%';
    document.body.style.overflowY = 'scroll'; /* keep scrollbar width so layout doesn't shift */
  }

  function unlockScroll() {
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.width = '';
    document.body.style.overflowY = '';
    window.scrollTo(0, scrollY);
  }

  function openModal() {
    var modal = document.getElementById('gorilla-nutrition-modal');
    if (!modal) return;
    modal.setAttribute('aria-hidden', 'false');
    modal.classList.add('gorilla-nutrition-modal--open');
    lockScroll();
    if (window.GorillaRichText) window.GorillaRichText.process();
    var close = modal.querySelector('.gorilla-nutrition-modal__close');
    if (close) close.focus();
  }

  function closeModal() {
    var modal = document.getElementById('gorilla-nutrition-modal');
    if (!modal) return;
    modal.setAttribute('aria-hidden', 'true');
    modal.classList.remove('gorilla-nutrition-modal--open');
    unlockScroll();
  }

  document.addEventListener('DOMContentLoaded', function () {
    var modal = document.getElementById('gorilla-nutrition-modal');
    if (!modal) return;

    /* Portal to <body> so no parent stacking context can trap the modal */
    document.body.appendChild(modal);

    modal.querySelectorAll('[data-nutrition-modal-close]').forEach(function (el) {
      el.addEventListener('click', closeModal);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeModal();
    });

    var flavorSel = modal.querySelector('[data-nutrition-flavor-select]');
    var labelImg  = document.getElementById('gorilla-nutrition-label-img');

    if (flavorSel) {
      flavorSel.addEventListener('change', function () {
        var opt    = flavorSel.options[flavorSel.selectedIndex];
        var handle = opt.value;
        var img    = opt.getAttribute('data-img');

        if (labelImg && img) {
          labelImg.src = img;
          labelImg.alt = opt.textContent.trim();
        }

        modal.querySelectorAll('[data-ingr-handle]').forEach(function (el) {
          el.style.display = el.getAttribute('data-ingr-handle') === handle ? '' : 'none';
        });
      });
    }
  });

  window.addEventListener('nutrition-modal:open', openModal);
})();
